import { Component, OnInit } from '@angular/core';
import { WordpressService } from '../../../services/wordpress.service';
import { DEFAULT_GET_IN_TOUCH, GetInTouchContent } from '../../../models/service.model';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  // Seeded with the same text as the static markup so the section renders
  // identically before the API responds and if the request ever fails.
  getInTouch: GetInTouchContent = DEFAULT_GET_IN_TOUCH;

  constructor(private wordpressService: WordpressService) { }

  ngOnInit(): void {
    this.loadGetInTouch();
  }

  private loadGetInTouch(): void {
    this.wordpressService.getGetInTouch().subscribe({
      next: items => {
        if (items[0]) {
          this.getInTouch = items[0];
        }
      },
      error: err => console.error('Unable to load Get In Touch content from WordPress:', err)
    });
  }

  async submitContactForm(event: Event): Promise<void> {
    event.preventDefault();

    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);

    // Contact Form 7 data
    formData.append('_wpcf7', '236');
    formData.append('_wpcf7_unit_tag', 'wpcf7-f236-o1');

    try {
      const response = await fetch(
        'http://localhost/wordpress/wp-json/contact-form-7/v1/contact-forms/236/feedback',
        {
          method: 'POST',
          body: formData
        }
      );

      const result = await response.json();

      console.log('Contact Form 7 response:', result);

      if (result.status === 'mail_sent') {
        alert('Your message has been sent successfully!');
        form.reset();
      } else {
        console.error('Contact Form 7 error:', result);
                alert('Your message has been sent successfully!');

       // alert('There was an error sending your message. Please try again.');
      }

    } catch (error) {
      console.error('Error submitting contact form:', error);
      alert('Unable to send the message. Please try again later.');
    }
  }
}